import { LookupFields, UserFields } from "src/modules/modules.type";
import { FIELDS_TYPES } from "./type.config";
import { Moment } from "moment";
import { LookUpRecord, UserRecord } from "src/types/main";

export const myTasksIncidentstPerPage = 500;
export const myTasksIncidentstListName = "MyTasksIncidents";
export const myTasksIncidentstWithRelationsListName = "MyTasksIncidentsSP";
export const myTasksIncidentsQuestionsListName = "MyTasksIncidentsQuestions";
export const myTasksTypeIncidentsListName = "MyTasksTypeIncidents";
export const myTaskIncCommentsListName = "MyTaskIncComments";
export const myTaskIncCommentsFilesListName = "MyTaskIncCommentsFiles";
export const myTasksIncidentsStatusesListName = "MyTasksIncidentsStatuses";
export const myTasksIncidentsRecipientsListListName =
  "MyTasksIncidentsRecipientsList";
export const myTasksIncidentCardRecipientsListName =
  "MyTasksIncidentCardRecipientsList";

export const MyTaskIncNameFields = {
  [myTasksIncidentCardRecipientsListName]: {
    ID: FIELDS_TYPES.ID,
    Recipients: FIELDS_TYPES.STRING,
    Copies: FIELDS_TYPES.STRING,
    Location: FIELDS_TYPES.LOOKUP,
    TypeIncident: FIELDS_TYPES.LOOKUP,
    QType: FIELDS_TYPES.STRING,
  },
  [myTasksIncidentsRecipientsListListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Emails: FIELDS_TYPES.STRING,
    Copies: FIELDS_TYPES.STRING,
  },
  [myTasksIncidentsStatusesListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Color: FIELDS_TYPES.STRING,
    TextInc: FIELDS_TYPES.STRING,
    TextN: FIELDS_TYPES.STRING,
  },
  [myTasksIncidentstWithRelationsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    AuthorEmail: FIELDS_TYPES.STRING,
    TypeIncident: FIELDS_TYPES.LOOKUP,
    DateIncidents: FIELDS_TYPES.DATE,
    TimeIncident: FIELDS_TYPES.STRING,
    Responsible: FIELDS_TYPES.USER,
    ResponsibleEmail: FIELDS_TYPES.STRING,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
    Description: FIELDS_TYPES.STRING,
    Questions: FIELDS_TYPES.MULTI_STRING_AND,
    ClosedDate: FIELDS_TYPES.DATE,
    Status: FIELDS_TYPES.LOOKUP,
    Status_x003a_Color: FIELDS_TYPES.LOOKUP,
    DateIncidents2: FIELDS_TYPES.DATE,
    View: FIELDS_TYPES.BOOLEAN,
    Hide: FIELDS_TYPES.BOOLEAN,
  },
  [myTasksIncidentstListName]: {
    MOldId: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    AuthorEmail: FIELDS_TYPES.STRING,
    TypeIncident: FIELDS_TYPES.LOOKUP,
    DateIncidents: FIELDS_TYPES.DATE,
    TimeIncident: FIELDS_TYPES.STRING,
    Responsible: FIELDS_TYPES.USER,
    ResponsibleEmail: FIELDS_TYPES.STRING,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
    Description: FIELDS_TYPES.STRING,
    Questions: FIELDS_TYPES.MULTI_STRING_AND,
    ClosedDate: FIELDS_TYPES.DATE,
    Status: FIELDS_TYPES.LOOKUP,
    Status_x003a_Color: FIELDS_TYPES.LOOKUP,
    DateIncidents2: FIELDS_TYPES.DATE,
    View: FIELDS_TYPES.BOOLEAN,
    Author: FIELDS_TYPES.USER,
    Editor: FIELDS_TYPES.USER,
    ResponsibleDepartment: FIELDS_TYPES.STRING,
    Fixed: FIELDS_TYPES.BOOLEAN,
    UserFinished: FIELDS_TYPES.STRING,
    DateFinished: FIELDS_TYPES.DATE,
    Hide: FIELDS_TYPES.BOOLEAN,
  },
  [myTasksIncidentsQuestionsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Key: FIELDS_TYPES.STRING,
    TypeQuestion: FIELDS_TYPES.CHOICE,
    Options: FIELDS_TYPES.STRING,
    Require: FIELDS_TYPES.BOOLEAN,
    DefaultHide: FIELDS_TYPES.BOOLEAN,
    TypeIncident: FIELDS_TYPES.LOOKUP,
    Condition: FIELDS_TYPES.STRING,
    Order: FIELDS_TYPES.NUMBER,
    Disabled: FIELDS_TYPES.BOOLEAN,
    Width: FIELDS_TYPES.STRING,
    NoticeAnswers: FIELDS_TYPES.STRING,
    Notice: FIELDS_TYPES.STRING,
  },
  [myTasksTypeIncidentsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
  },
  [myTaskIncCommentsFilesListName]: {
    ID: FIELDS_TYPES.ID,
    Comment: FIELDS_TYPES.LOOKUP,
    ForHistory: FIELDS_TYPES.BOOLEAN,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
  },
  [myTaskIncCommentsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    TextComment: FIELDS_TYPES.STRING,
    Incident: FIELDS_TYPES.LOOKUP,
    Created: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
  },
};

export type MyTaskIncFieldsRecordType = {
  [myTasksIncidentCardRecipientsListName]: {
    ID: number;
    Recipients: string;
    Copies: string;
    Location: LookupFields;
    TypeIncident: LookupFields;
    QType: string;
  };
  [myTasksIncidentsRecipientsListListName]: {
    ID: number;
    Title: string;
    Emails: string;
    Copies: string;
  };
  [myTasksIncidentsStatusesListName]: {
    ID: number;
    Title: string;
    Color: string;
    TextInc: string;
    TextN: string;
  };
  [myTasksIncidentstWithRelationsListName]: {
    ID: number;
    Title: string;
    AuthorEmail: string;
    TypeIncident: LookupFields;
    DateIncidents: Date;
    TimeIncident: string;
    Responsible: UserFields;
    ResponsibleEmail: string;
    Location: LookupFields;
    Department: LookupFields;
    Region: LookupFields;
    Description: string;
    Questions: string;
    ClosedDate: Date;
    Status: LookupFields;
    Status_x003a_Color: LookupFields;
    DateIncidents2: Date;
    View: boolean;
    Hide: boolean;
  };
  [myTasksIncidentstListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    AuthorEmail: string;
    TypeIncident: LookupFields;
    DateIncidents: Date;
    TimeIncident: string;
    Responsible: UserFields;
    ResponsibleEmail: string;
    Location: LookupFields;
    Department: LookupFields;
    Region: LookupFields;
    Description: string;
    Questions: string;
    ClosedDate: Date;
    Status: LookupFields;
    Status_x003a_Color: LookupFields;
    DateIncidents2: Date;
    View: boolean;
    Author: UserFields;
    Editor: UserFields;
    ResponsibleDepartment: string;
    Fixed: boolean;
    UserFinished: string;
    DateFinished: Date;
    Hide: boolean;
  };
  [myTasksIncidentsQuestionsListName]: {
    ID: number;
    Title: string;
    Key: string;
    TypeQuestion: string;
    Options: string;
    Require: boolean;
    DefaultHide: boolean;
    TypeIncident: LookupFields;
    Condition: string;
    Order: number;
    Disabled: boolean;
    Width: string;
    NoticeAnswers: string;
    Notice: string;
  };
  [myTasksTypeIncidentsListName]: {
    ID: number;
    Title: string;
  };
  [myTaskIncCommentsFilesListName]: {
    ID: number;
    Comment: LookupFields;
    ForHistory: boolean;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
  [myTaskIncCommentsListName]: {
    ID: number;
    Title: string;
    TextComment: string;
    Incident: LookupFields;
    Created: Date;
    Author: UserFields;
  };
};

export type MyTaskIncFieldsType = {
  [myTasksIncidentCardRecipientsListName]: {
    ID: number;
    Recipients: string;
    Copies: string;
    Location: LookUpRecord;
    TypeIncident: LookUpRecord;
    QType: string;
  };
  [myTasksIncidentsRecipientsListListName]: {
    ID: number;
    Title: string;
    Emails: string;
    Copies: string;
  };
  [myTasksIncidentsStatusesListName]: {
    ID: number;
    Title: string;
    Color: string;
    TextInc: string;
    TextN: string;
  };
  [myTasksIncidentstWithRelationsListName]: {
    ID: number;
    Title: string;
    AuthorEmail: string;
    TypeIncident: LookUpRecord;
    DateIncidents: Moment;
    TimeIncident: string;
    Responsible: UserRecord;
    ResponsibleEmail: string;
    Location: LookUpRecord;
    Department: LookUpRecord;
    Region: LookUpRecord;
    Description: string;
    Questions: string;
    ClosedDate: Moment;
    Status: LookUpRecord;
    Status_x003a_Color: LookUpRecord;
    DateIncidents2: Moment;
    View: boolean;
    Hide: boolean;
  };
  [myTasksIncidentstListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    AuthorEmail: string;
    TypeIncident: LookUpRecord;
    DateIncidents: Moment;
    TimeIncident: string;
    Responsible: UserRecord;
    ResponsibleEmail: string;
    Location: LookUpRecord;
    Department: LookUpRecord;
    Region: LookUpRecord;
    Description: string;
    Questions: string;
    ClosedDate: Moment;
    Status: LookUpRecord;
    Status_x003a_Color: LookUpRecord;
    DateIncidents2: Moment;
    View: boolean;
    Author: UserRecord;
    Editor: UserRecord;
    ResponsibleDepartment: string;
    Fixed: boolean;
    UserFinished: string;
    DateFinished: Moment;
    Hide: boolean;
  };
  [myTasksIncidentsQuestionsListName]: {
    ID: number;
    Title: string;
    Key: string;
    TypeQuestion: string;
    Options: string;
    Require: boolean;
    DefaultHide: boolean;
    TypeIncident: LookUpRecord;
    Condition: string;
    Order: number;
    Disabled: boolean;
    Width: string;
    NoticeAnswers: string;
    Notice: string;
  };
  [myTasksTypeIncidentsListName]: {
    ID: number;
    Title: string;
  };
  [myTaskIncCommentsFilesListName]: {
    ID: number;
    Comment: LookUpRecord;
    ForHistory: boolean;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
  [myTaskIncCommentsListName]: {
    ID: number;
    Title: string;
    TextComment: string;
    Incident: LookUpRecord;
    Created: Moment;
    Author: UserRecord;
  };
};
